
import React from 'react';
import logo from '../assets/images/Logo.png';
import styles from '../styles/TermsAndConditions.module.css';

const TermsAndConditions = () => (
  <div className={styles['terms-container']}>
    <div className={styles['terms-header-row']}>
      <div className={styles['aboutus-logo-col']}>
        <img src={logo} alt="AstroShubh Logo" className={styles['terms-logo']} />
      </div>
      <div className={styles['terms-title-col']}>
        <h1 className={styles['terms-title']}>Terms & Conditions</h1>
        <p className={styles['terms-company-info']}>
          <span><strong>Website:</strong> www.astroshubh.com</span><br/>
          <span><strong>Operated by:</strong> Tara Infotech ("Company")</span><br/>
          <span><strong>Brand Name:</strong> AstroShubh</span>
        </p>
      </div>
    </div>
    <div className={styles['terms-content']}>
      <h2 className={styles['terms-main-title']}>Terms & Conditions</h2>
      <div className={styles['terms-section-text']}>
        <p>This website, https://astroshubh.com (“Website”), is owned and operated by Tara Infotech, hereinafter referred to as “AstroShubh” or “Company” or “we” or “us” or “our”.</p>
        <p>Please read these Terms and Conditions carefully before using this Website. By visiting our Website and/or purchasing any product or service, you agree to be bound by the following Terms (“Terms and Conditions” / “Terms of Service”).</p>
        <p>If you do not agree to these Terms, please refrain from using the Website or Services.</p>
        <h3>SECTION 1 – INTRODUCTION</h3>
        <p>AstroShubh provides astrological content, consultations, reports, e-books, digital remedies, and related services (collectively, “Content”). Some content may be free (“Free Services”), while personalized or premium content may require payment (“Paid Services”).</p>
        <h3>SECTION 2 – GENERAL COVENANTS</h3>
        <p>We reserve the right to refuse or cancel any order at our sole discretion due to issues including technical errors, limitations in availability, or incorrect information provided.</p>
        <h3>SECTION 3 – SITE SECURITY</h3>
        <p>Users must not attempt to hack, misuse, inject malware, or disrupt the Website. Any fraudulent use may result in legal action.</p>
        <h3>SECTION 4 – ACCURACY & RELIABILITY</h3>
        <p>The Website and its content are provided on an “AS IS” basis. While reasonable efforts are made to ensure accuracy, we do not guarantee results. Astrology is interpretive; outcomes vary from person to person. Services are intended for guidance, not as substitutes for professional medical, legal, or financial advice.</p>
        <h3>SECTION 5 – DELIVERY</h3>
        <ul>
          <li>Digital products (remedies, reports, PDFs) are delivered via email/WhatsApp/download link.</li>
          <li>Physical products (if any) are subject to courier timelines. We are not liable for delays caused by third-party carriers or customs.</li>
        </ul>
        <h3>SECTION 6 – PAYMENT & PRICING</h3>
        <ul>
          <li>Prices are in INR and inclusive of applicable taxes.</li>
          <li>Payments accepted via Razorpay/Cashfree, UPI, cards, or net banking.</li>
          <li>Prices may change without prior notice.</li>
          <li>Orders above ₹2,00,000 require PAN details as per law.</li>
        </ul>
        <h3>SECTION 7 – PAYMENT INFORMATION</h3>
        <p>You agree to provide valid and lawful payment details. Unauthorized transactions may lead to cancellation.</p>
        <h3>SECTION 8 – SERVICES DISCLAIMER</h3>
        <p>Astrological remedies, predictions, and consultations are intended for self-reflection and guidance. AstroShubh does not guarantee specific outcomes.</p>
        <h3>SECTION 9 – BILLING & ACCOUNT INFORMATION</h3>
        <p>You must provide accurate and updated billing details. We may cancel orders with incomplete or fraudulent information.</p>
        <h3>SECTION 10 – OPTIONAL TOOLS</h3>
        <p>We may provide access to third-party platforms or tools, which are offered “as is” and at your discretion.</p>
        <h3>SECTION 11 – THIRD-PARTY LINKS</h3>
        <p>Links to third-party websites are provided for convenience. We are not responsible for their content, products, or services.</p>
        <h3>SECTION 12 – USER FEEDBACK & SUBMISSIONS</h3>
        <p>Any suggestions, comments, or feedback may be used by us without restriction. You agree not to post unlawful, offensive, or infringing material.</p>
        <h3>SECTION 13 – PERSONAL INFORMATION</h3>
        <p>All personal information submitted is governed by our Privacy Policy.</p>
        <h3>SECTION 14 – ERRORS & OMISSIONS</h3>
        <p>We reserve the right to correct inaccuracies in product descriptions, pricing, or availability without prior notice.</p>
        <h3>SECTION 15 – PROHIBITED USES</h3>
        <ul>
          <li>Use the Website for unlawful activities.</li>
          <li>Harass, abuse, or discriminate against others.</li>
          <li>Upload malicious code.</li>
          <li>Attempt to scrape, spam, or collect personal data without consent.</li>
        </ul>
        <h3>SECTION 16 – INTELLECTUAL PROPERTY</h3>
        <p>All Website content (texts, reports, logos, images, software) belongs to Tara Infotech (AstroShubh). Unauthorized copying or redistribution is prohibited.</p>
        <h3>SECTION 17 – DISCLAIMER OF WARRANTIES</h3>
        <p>We do not warrant uninterrupted, error-free services. The Website and Services are provided “as available.”</p>
        <h3>SECTION 18 – LIMITATION OF LIABILITY</h3>
        <p>AstroShubh and Tara Infotech shall not be liable for direct, indirect, or consequential damages arising from the use of Services.</p>
        <h3>SECTION 19 – INDEMNIFICATION</h3>
        <p>Users agree to indemnify and hold AstroShubh harmless from any claims, damages, or liabilities arising from misuse or breach of Terms.</p>
        <h3>SECTION 20 – HATE SPEECH & CONTENT</h3>
        <p>Content promoting hatred, violence, or discrimination against individuals or groups is strictly prohibited and will lead to suspension.</p>
        <h3>SECTION 21 – SEVERABILITY</h3>
        <p>If any clause is held invalid, the rest of the Terms remain enforceable.</p>
        <h3>SECTION 22 – TERMINATION</h3>
        <p>We may terminate or suspend your access for breach of Terms. Obligations prior to termination will survive.</p>
        <h3>SECTION 23 – ENTIRE AGREEMENT</h3>
        <p>These Terms, together with Privacy and Refund Policies, form the entire agreement between you and AstroShubh.</p>
        <h3>SECTION 24 – FORCE MAJEURE</h3>
        <p>We are not liable for delays or failures caused by circumstances beyond our control (natural disasters, strikes, pandemics, government restrictions, etc.).</p>
        <h3>SECTION 25 – GOVERNING LAW & DISPUTE RESOLUTION</h3>
        <ul>
          <li><strong>Governing Law:</strong> These Terms are governed by the laws of India.</li>
          <li><strong>Jurisdiction:</strong> Any disputes shall be subject to arbitration in accordance with the Arbitration and Conciliation Act, 1996.</li>
          <li><strong>Place of Arbitration:</strong> Gurugram, Haryana.</li>
          <li>The decision of the arbitrator shall be final and binding.</li>
        </ul>
        <h3>SECTION 26 – CONTACT INFORMATION</h3>
        <p>For questions regarding these Terms, please contact us:</p>
        <p>📧 support@astroshubh.com</p>
      </div>
    </div>
  </div>
);

export default TermsAndConditions;
